import type {
	ApiState,
	ApiSuccessResponse,
	ExtendedFetchOptions
} from '@/types/api-client'
import type { AdminUser, CreateUserPayload } from '@/types/api-client/super-admin-users'

export function createSuperAdminUsersApi(
	request: <T>(endpoint: string, options?: ExtendedFetchOptions) => Promise<T | null>,
	createApiState: <T>(endpoint: string, options?: ExtendedFetchOptions) => ApiState<T>
) {
	return {
		create: (payload: CreateUserPayload, options: ExtendedFetchOptions = {}) => {
			return request<ApiSuccessResponse>('/sadmin/users/create', {
				method: 'POST',
				body: payload,
				...options
			})
		},
		useGetAll: (options: ExtendedFetchOptions = {}): ApiState<AdminUser[]> =>
			createApiState<AdminUser[]>('/sadmin/users', options)
	}
}
